/**
 * Stable empty object for default params
 */
export const EMPTY_PARAMS = Object.freeze({});

/**
 * Stable empty options object
 */
export const EMPTY_OPTIONS = Object.freeze({});
